var storefrontApp = angular.module("storefrontApp");
storefrontApp.service("giftCardService", [
    "$http",
    function ($http) {
        return {
            getAllGiftCards: function () {
                return $http.get("storefrontapi/account/getallgiftcards");
            },
            getActiveGiftCards: function () {
                return $http.get("storefrontapi/account/getactivegiftcards");
            },
            getGiftCardImages: function () {
                return $http.get("giftcard/giftcardimages");
            },
            isGiftCardExpired: function (expiryDate) {
                return (
                    expiryDate &&
                    new Date().valueOf() > new Date(expiryDate).valueOf()
                );
            },
            redeemGiftCard: function (activationCode) {
                return $http.post(
                    "storefrontapi/account/redeemgiftcard?uniqueGiftCardId=" +
                        activationCode
                );
            },
            applyGiftcardsOnCart: function (uniqueCertIds,paymentMethod){
                return $http.post('storefrontapi/cart/applygiftcardsoncart?uniqueCertIds=' + uniqueCertIds +'&paymentMethod=' + paymentMethod);
            },
        };
    },
]);
